import { render, staticRenderFns } from "./ProtectionModal.vue?vue&type=template&id=c794a7e2&"
import script from "./ProtectionModal.vue?vue&type=script&lang=ts&"
export * from "./ProtectionModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProtectionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports